<template>
  <v-btn
    v-if="icon"
    fab
    icon
    :small="isIconSize('small')"
    :x-small="isIconSize('x-small')"
    v-clipboard="() => copy"
    @click="onCopy"
  >
    <v-icon color="appMain" class="icon-outlined">
      {{ copied ? 'check' : 'content_copy' }}
    </v-icon>
  </v-btn>

  <v-btn v-else color="appMain" @click="onCopy" v-clipboard="() => copy">
    {{ copied ? 'Copied!' : 'Copy' }}
  </v-btn>
</template>

<script>
import Vue from 'vue';
import Clipboard from 'v-clipboard';
Vue.use(Clipboard);

export default {
  name: 'CopyBtn',
  props: {
    copy: [String, Number],
    icon: Boolean,
    iconSize: {
      type: String,
      default: 'x-small',
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    isIconSize(size) {
      return this.iconSize === size;
    },
    onCopy() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
  },
};
</script>
